import React from "react";
import { ChevronDown, ChevronUp, Search, LayoutGrid, List } from "lucide-react";

class EventSchedule extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      scheduleData: {},
      locationData: [],
      activeTab: "",
      showInfoPanel: false,
      loading: true,
      selectedLocation: "all",
      searchText: "",
      view: "grid", // 'list' or 'grid'
      expandedEvent: null,
      tagColors: {
        "Meet & Greet": "rgba(188, 189, 34, 0.3)",
        "Film Festival": "rgba(173, 216, 230, 0.6)",
        Gaming: "rgba(144, 238, 144, 0.6)",
        "Special Event": "rgba(255, 218, 185, 0.6)",
        "Media Guest": "rgba(221, 160, 221, 0.6)",
        Creators: "rgba(255, 182, 193, 0.6)",
        Wrestling: "rgba(255, 160, 122, 0.6)",
        Comics: "rgba(176, 196, 222, 0.6)",
        Cosplay: "rgba(255, 218, 185, 0.6)",
        Programming: "rgba(211, 211, 211, 0.6)",
        Performances: "rgba(216, 191, 216, 0.6)",
        Vendors: "rgba(176, 224, 230, 0.6)",
        Theater: "rgba(255, 222, 173, 0.6)",
        Autographs: "rgba(144, 238, 144, 0.6)",
        "Photo Ops": "rgba(255, 182, 193, 0.6)",
        Workshops: "rgba(221, 160, 221, 0.6)",
        VIP: "rgba(176, 196, 222, 0.6)",
        Registration: "rgba(211, 211, 211, 0.6)",
      },
    };
  }

  componentDidMount() {
    this.fetchScheduleData();
  }

  fetchScheduleData() {
    fetch("https://mobile.creationent.com/data/data_fullEvent.php?eventId=50")
      .then((response) => response.json())
      .then((data) => {
        const _scheduleData = data.eventInfo.schedule;

        const dates = _scheduleData
          .reduce((accumulator, currentObject) => {
            if (!accumulator.includes(currentObject.date)) {
              accumulator.push(currentObject.date);
            }
            return accumulator;
          }, [])
          .sort((a, b) => new Date(a) - new Date(b));

        const scheduleData = _scheduleData.reduce(
          (accumulator, currentObject) => {
            const date = currentObject.date;
            if (!accumulator[date]) {
              accumulator[date] = [];
            }
            accumulator[date].push(currentObject);
            return accumulator;
          },
          {}
        );

        Object.keys(scheduleData).forEach((date) => {
          scheduleData[date].sort(
            (a, b) =>
              new Date(`${date} ${a.time}`) - new Date(`${date} ${b.time}`)
          );
        });

        const locationData = _scheduleData.reduce(
          (accumulator, currentObject) => {
            const location = currentObject.location;
            if (!accumulator.includes(location)) {
              accumulator.push(location);
            }
            return accumulator;
          },
          []
        );

        const today = new Date().toLocaleDateString("en-US");
        const activeTab = dates.includes(today) ? today : dates[0];

        this.setState({
          scheduleData,
          activeTab: activeTab,
          loading: false,
          locationData: locationData,
        });
      });
  }

  toggleView = () => {
    this.setState((prevState) => ({
      view: prevState.view === "grid" ? "list" : "grid",
    }));
  };

  setActiveTab(date) {
    this.setState({ activeTab: date });
  }

  handleLocationChange = (event) => {
    this.setState({ selectedLocation: event.target.value });
  };

  handleSearchChange = (event) => {
    this.setState({ searchText: event.target.value });
  };

  toggleEventExpansion = (eventId) => {
    this.setState((prevState) => ({
      expandedEvent: prevState.expandedEvent === eventId ? null : eventId,
    }));
  };

  renderDateTabs() {
    const { scheduleData, activeTab } = this.state;
    const sortedDates = Object.keys(scheduleData).sort(
      (a, b) => new Date(a) - new Date(b)
    );

    return (
      <div className="dates-scroll mb-3 overflow-x-auto">
        <div className="flex space-x-2 p-1">
          {sortedDates.map((date) => (
            <button
              key={date}
              onClick={() => this.setActiveTab(date)}
              className={`flex-none px-4 py-2 rounded-full text-gray-700 ${
                activeTab === date ? "background-grey" : "bg-gray-100"
              }`}
            >
              {date}
            </button>
          ))}
        </div>
      </div>
    );
  }

  renderFilters() {
    const { locationData, selectedLocation, searchText, view } = this.state;

    return (
      <div className="space-y-3 mb-4">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
          <input
            type="text"
            className="w-full pl-10 pr-4 py-2 rounded-lg border"
            placeholder="Search events..."
            value={searchText}
            onChange={this.handleSearchChange}
          />
        </div>
        <div className="flex space-x-2">
          <select
            className="flex-1 p-2 rounded-lg border"
            value={selectedLocation}
            onChange={this.handleLocationChange}
          >
            <option value="all">All Locations</option>
            {locationData.map((location, index) => (
              <option key={index} value={location}>
                {location}
              </option>
            ))}
          </select>
          <button
            onClick={this.toggleView}
            className="p-2 rounded-lg border bg-white"
          >
            {view === "list" ? (
              <LayoutGrid className="h-5 w-5 text-gray-600" />
            ) : (
              <List className="h-5 w-5 text-gray-600" />
            )}
          </button>
        </div>
      </div>
    );
  }

  renderListView() {
    const {
      scheduleData,
      activeTab,
      selectedLocation,
      searchText,
      expandedEvent,
      tagColors,
    } = this.state;
    const activeSchedule = scheduleData[activeTab];

    if (!activeSchedule) return null;

    const filteredSchedule = activeSchedule.filter(
      (item) =>
        (selectedLocation === "all" || item.location === selectedLocation) &&
        item.event.toLowerCase().includes(searchText.toLowerCase())
    );

    return (
      <div className="space-y-4">
        {filteredSchedule.map((event, index) => (
          <div
            key={index}
            className="bg-white rounded-lg shadow-sm p-4 border-l-4"
            style={{
              borderLeftColor: tagColors[event.tags[0]],
            }}
          >
            <div className="flex justify-between items-start">
              <div className="flex-1">
                <div className="text-lg font-semibold">{event.event}</div>
                <div className="text-sm text-gray-600">
                  {event.time} • {event.location}
                </div>
                {expandedEvent === index && (
                  <div className="mt-2 text-sm">
                    <span
                      className="inline-block px-2 py-1 rounded-full text-xs"
                      style={{ backgroundColor: tagColors[event.tags[0]] }}
                    >
                      {event.tags[0]}
                    </span>
                  </div>
                )}
              </div>
              <button
                onClick={() => this.toggleEventExpansion(index)}
                className="ml-2 text-gray-400 hover:text-gray-600"
              >
                {expandedEvent === index ? (
                  <ChevronUp className="h-5 w-5" />
                ) : (
                  <ChevronDown className="h-5 w-5" />
                )}
              </button>
            </div>
          </div>
        ))}
      </div>
    );
  }

  renderGridView() {
    const {
      scheduleData,
      activeTab,
      locationData,
      tagColors,
      selectedLocation,
      searchText,
    } = this.state;
    const activeSchedule = scheduleData[activeTab];

    if (!activeSchedule) return null;

    const filteredSchedule = activeSchedule.filter((item) =>
      item.event.toLowerCase().includes(searchText.toLowerCase())
    );

    const displayLocations =
      selectedLocation === "all" ? locationData : [selectedLocation];
    const times = [...new Set(filteredSchedule.map((item) => item.time))];

    return (
      <div className="table-responsive schedule-table">
        <table className="table table-bordered table-hover">
          <thead className="thead-light">
            <tr>
              <th className="sticky">Time</th>
              {displayLocations.map((location, index) => (
                <th key={index}>{location}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {times.map((time, index) => (
              <tr key={index}>
                <td className="font-weight-bold sticky">{time}</td>
                {displayLocations.map((location, locIndex) => {
                  const scheduleItem = filteredSchedule.find(
                    (item) => item.time === time && item.location === location
                  );
                  return (
                    <td
                      key={locIndex}
                      style={{
                        backgroundColor: scheduleItem
                          ? tagColors[scheduleItem.tags[0]]
                          : "transparent",
                        color: scheduleItem ? "#000000" : "inherit",
                      }}
                    >
                      {scheduleItem ? (
                        <div className="event-name">{scheduleItem.event}</div>
                      ) : (
                        ""
                      )}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const { loading, view } = this.state;

    return (
      <div className="page-wrapper">
        <main className="page-content">
          <div className="content-container max-w-7xl mx-auto px-4">
            <h2 className="text-2xl font-bold mt-4 mb-3">Event Schedule</h2>
            {loading ? (
              <p>Loading...</p>
            ) : (
              <>
                {this.renderDateTabs()}
                {this.renderFilters()}
                {view === "list"
                  ? this.renderListView()
                  : this.renderGridView()}
              </>
            )}
          </div>
        </main>
        <footer className="page-footer mt-8 py-4 text-center text-gray-600">
          <p>© 2025 Pensacon. All Rights Reserved.</p>
        </footer>
      </div>
    );
  }
}

export default EventSchedule;
